import React, {useMemo}								from 'react';
import {ProgressBarProps}							from './interface';

import './ProgressBar.css';

const defaultProps: ProgressBarProps = {
	maxValue: 100,
	value:    0,
	style:    {}
};

function ProgressBar(props: ProgressBarProps) {
	props = {...defaultProps, ...props};

	const pourcent = useMemo(
		() => (100 * (props.value || 0)) / (props.maxValue || 0),
		[props.style, props.value, props.maxValue]
	);

	if (props.style?.height && !props.style.minHeight)
		props.style.minHeight = props.style.height;

	return (
		<div className={'progressBar'} style={props.style}>
			<div style={{backgroundColor: props.color || '', width: `${pourcent}%`}} />
		</div>
	);
}

export default ProgressBar;
